/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="13.71"
        viewBox="0 0 19 13.71"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M6.33 0H0v13.71h19V1.76H7.59ZM18 12.71H1V5.4h17Zm0-8.31H1V1h4.82l1.26 1.76H18Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'FolderIcon';

export default Icon;
